<script setup>
import { Link } from '@inertiajs/vue3'
import { uuid } from '@/helpers'

const cardDateCategory = defineAsyncComponent(() => import('../CardDateCategory.vue'))
const labelHighlighted = defineAsyncComponent(() => import('../labels/LabelTextLabel.vue'))

const props = defineProps({
	item: {
		type: Object,
		default: () => {},
		required: true,
	},
	tag: {
		type: String,
		default: 'div',
	},
	video: {
		type: Boolean,
		default: false,
	},
})

const appStore = useAppStore()
</script>

<template>
	<component
		:is="tag"
		class="custom-card custom-card-plain"
		:data-item-id="item.id ?? uuid('article-')"
		style="--card-bg: none"
	>
		<div class="custom-card-img-wrapper mb-3">
			<label-highlighted
				v-if="item.premium === 2"
				:text="$t('Premium')"
				class="bg-white position-absolute z-3 ms-3 mt-3"
			/>
			<theme-video-label
				v-if="video"
				class="text-gold-500"
				:size="appStore.isMobile ? 52 : 72"
			/>
			<slot
				name="img"
				:meta="{
					imgSource: item.image?.url || item.teaser,
					imgCropping: item.image?.cropping || item.teaser_cropping,
					imgAlt: item.image?.alt || item.teaser_alt,
				}"
			>
				<img
					:src="
						$thumbor(item.image?.url || item.teaser)
							.dimension(250, 150)
							.url()
					"
					class="custom-card-img image-fluid bg-neutral-300 w-100"
					loading="lazy"
					:alt="item.title"
				/>
			</slot>
		</div>

		<section class="custom-card-contents px-0 pb-0">
			<div class="h6 custom-card-title fw-medium mb-0">{{ item.title }}</div>
			<card-date-category
				:datetime="item.published_at"
				:category="item.main_category?.name || item.main_category"
			/>
		</section>
		<Link
			:href="item?.route?.slug || item.slug"
			class="stretched-link"
			:aria-label="$t('Read more :about', { about: item.title })"
		/>
	</component>
</template>
